module.exports = __webpack_public_path__ + "static/media/bio_age_per_to_wor.2f1d695f.png";